<template>
    <div class="min-h-screen font-sans antialiased relative">
      <div class="relative">
        <div
          class="cover-gradient-2 sm:cover-gradient"
        ></div>
        <BaseNavbar />
  
        <main class="text-neutral-800">
          <h1>{{ error.statusCode }} - {{ error.message }}</h1>
           Sayfa bulunamadı.
        </main>
  
        <BaseFooter2 />
      </div>
    </div>
  </template>
  <script>
  export default {
    name: 'DefaultLayout',
  }
  </script> 
  <script setup>
  const { isMobile } = useDevice();
  defineProps({
    error: Object,
  })
  </script>
  <style>@import "~/assets/css/default.css"; @import "~/assets/css/main.css";</style>
  <style lang="scss">@import "~/assets/css/main.scss";</style>
